
    import '/opt/buildhome/repo/docs/playground/copilot.zh-CN.md?watch=parent';
    export const demoIndex = {
  ids: ["docs-playground-copilot-demo-copilot"],
  getter: () => import(/* webpackChunkName: "meta__docs__zh-CN" */'/opt/buildhome/repo/docs/playground/copilot.zh-CN.md?type=demo')
};